export const translations = {
  en: {
    nav: {
      schedule: 'Schedule',
      location: 'Location',
      dresscode: 'Dress code',
      stay: 'Stay',
      rsvp: 'RSVP',
    },
    hero: {
      eyebrow: 'Together with their families',
      title: 'Joan & Sofia',
      date: 'May 22, 2027',
      message: "We can't wait to celebrate with you",
      cta: 'RSVP',
      scroll: 'Scroll to discover',
    },
    story: {
      eyebrow: 'Our celebration',
      title: 'A day to remember',
      copy: 'We are so excited to gather everyone we love in one beautiful place. More details will follow soon.',
      details: 'Details coming soon',
    },
    schedule: {
      eyebrow: 'The day',
      title: 'Schedule',
      items: [
        { time: '3:00 PM', title: 'Ceremony', copy: 'Join us as we say “I do”.' },
        { time: '4:30 PM', title: 'Cocktails', copy: 'Raise a glass and enjoy the afternoon.' },
        { time: '6:00 PM', title: 'Dinner & dancing', copy: 'Good food,happy tears and a full dance floor.' },
      ],
    },
    location: {
      eyebrow: 'Find us',
      title: 'Location',
      name: 'Restaurant Can Mont Cad',
      copy: 'Avinguda Pau Vila,1,08181 Pedra-Santa,Sentmenat,Barcelona.',
      button: 'Get directions',
      website: 'Visit website',
    },
    dresscode: {
      eyebrow: 'What to wear',
      title: 'Dress code',
      copy: 'Dress to impress,but please avoid white and red.',
    },
    stay: {
      eyebrow: 'Plan your visit',
      title: 'Accommodation & transport',
      hotels: [
        { name: 'The Garden Hotel', detail: 'Placeholder hotel · 10 min from venue' },
        { name: 'Casa del Mar', detail: 'Placeholder hotel · 15 min from venue' },
        { name: 'The Riverside Inn', detail: 'Placeholder hotel · 20 min from venue' },
      ],
      note: 'A shuttle bus will be provided between the accommodation areas and the venue. More details will be shared closer to the date.',
    },
    rsvp: {
      eyebrow: 'We hope you can join us',
      title: 'Will you be there?',
      copy: 'Please let us know if you can celebrate with us.',
    },
    rsvpForm: {
      name: 'Your name',
      namePlaceholder: 'Enter your name',
      email: 'Email address',
      emailPlaceholder: 'you@example.com',
      attendance: 'Will you attend?',
      yes: 'Yes',
      no: 'No',
      guestCount: 'Number of guests',
      guestCountPlaceholder: 'Number of guests',
      dietary: 'Dietary requirements',
      dietaryPlaceholder: 'Share any dietary requirements',
      message: 'Message',
      messagePlaceholder: 'Add a message (optional)',
      submit: 'Send RSVP',
      sending: 'Sending...',
      success: 'Thank you. Your RSVP was saved.',
      error: 'We could not save your RSVP. Please try again.',
    },
    gifts: {
      eyebrow: 'A little note',
      title: 'Gifts',
      copy: 'Your presence is the greatest gift. If you would like to contribute to our honeymoon,you can use the details below.',
      accountLabel: 'IBAN / Account number',
      account: 'IBAN PLACEHOLDER · ACCOUNT 0000 0000 0000',
      copyButton: 'Copy to clipboard',
      copied: 'Copied',
    },
    footer: 'With love,Joan & Sofia',
  },
  es: {
    nav: {
      schedule: 'Horario',
      location: 'Ubicación',
      dresscode: 'Vestimenta',
      stay: 'Alojamiento',
      rsvp: 'Asistencia',
    },
    hero: {
      eyebrow: 'Junto a nuestras familias',
      title: 'Joan & Sofia',
      date: '22 de mayo de 2027',
      message: 'Estamos deseando celebrarlo con vosotros',
      cta: 'Confirmar asistencia',
      scroll: 'Descubre más',
    },
    story: {
      eyebrow: 'Nuestra celebración',
      title: 'Un día para recordar',
      copy: 'Estamos deseando reunir a todas las personas que queremos en un lugar precioso. Pronto compartiremos más detalles.',
      details: 'Detalles próximamente',
    },
    schedule: {
      eyebrow: 'El día',
      title: 'Horario',
      items: [
        { time: '15:00', title: 'Ceremonia', copy: 'Acompañadnos mientras decimos «sí,quiero».' },
        { time: '16:30', title: 'Cóctel', copy: 'Brindemos juntos y disfrutemos de la tarde.' },
        { time: '18:00', title: 'Cena y baile', copy: 'Buena comida,lágrimas de alegría y una pista llena.' },
      ],
    },
    location: {
      eyebrow: 'Cómo llegar',
      title: 'Ubicación',
      name: 'Restaurante Can Mont Cad',
      copy: 'Avinguda Pau Vila,1,08181 Pedra-Santa,Sentmenat,Barcelona.',
      button: 'Cómo llegar',
      website: 'Visitar sitio web',
    },
    dresscode: {
      eyebrow: 'Qué ponerse',
      title: 'Vestimenta',
      copy: 'Vestid para impresionar,pero por favor evitad el blanco y el rojo.',
    },
    stay: {
      eyebrow: 'Planificad vuestra visita',
      title: 'Alojamiento y transporte',
      hotels: [
        { name: 'The Garden Hotel', detail: 'Hotel provisional · a 10 min del lugar' },
        { name: 'Casa del Mar', detail: 'Hotel provisional · a 15 min del lugar' },
        { name: 'The Riverside Inn', detail: 'Hotel provisional · a 20 min del lugar' },
      ],
      note: 'Habrá un autobús lanzadera entre las zonas de alojamiento y el lugar de celebración. Compartiremos más detalles cuando se acerque la fecha.',
    },
    rsvp: {
      eyebrow: 'Esperamos que podáis acompañarnos',
      title: '¿Estaréis con nosotros?',
      copy: 'Contadnos si podéis celebrar este día tan especial.',
    },
    rsvpForm: {
      name: 'Nombre y apellidos',
      namePlaceholder: 'Escribe tu nombre',
      email: 'Correo electrónico',
      emailPlaceholder: 'tu@ejemplo.com',
      attendance: '¿Asistirás?',
      yes: 'Sí',
      no: 'No',
      guestCount: 'Número de invitados',
      guestCountPlaceholder: 'Número de invitados',
      dietary: 'Requisitos alimentarios',
      dietaryPlaceholder: 'Indica cualquier requisito alimentario',
      message: 'Mensaje',
      messagePlaceholder: 'Añade un mensaje (opcional)',
      submit: 'Enviar confirmación',
      sending: 'Enviando...',
      success: 'Gracias. Hemos guardado tu confirmación.',
      error: 'No hemos podido guardar tu confirmación. Inténtalo de nuevo.',
    },
    gifts: {
      eyebrow: 'Una pequeña nota',
      title: 'Regalos',
      copy: 'Vuestra presencia es el mejor regalo. Si queréis contribuir a nuestra luna de miel,podéis utilizar los datos siguientes.',
      accountLabel: 'IBAN / Número de cuenta',
      account: 'IBAN PROVISIONAL · CUENTA 0000 0000 0000',
      copyButton: 'Copiar al portapapeles',
      copied: 'Copiado',
    },
    footer: 'Con cariño,Joan & Sofia',
  },
  ca: {
    nav: {
      schedule: 'Programa',
      location: 'Ubicació',
      dresscode: 'Codi de vestimenta',
      stay: 'Allotjament',
      rsvp: 'Assistència',
    },
    hero: {
      eyebrow: 'Acompanyats de les nostres famílies',
      title: 'Joan & Sofia',
      date: '22 de maig de 2027',
      message: 'Tenim moltes ganes de celebrar-ho amb vosaltres',
      cta: 'Confirmeu l’assistència',
      scroll: 'Desplaceu-vos per descobrir',
    },
    story: {
      eyebrow: 'La nostra celebració',
      title: 'Un dia per recordar',
      copy: 'Ens fa molta il·lusió reunir totes les persones que estimem en un lloc preciós. Aviat us donarem més detalls.',
      details: 'Més detalls ben aviat',
    },
    schedule: {
      eyebrow: 'El gran dia',
      title: 'Programa',
      items: [
        { time: '15.00 h', title: 'Cerimònia', copy: 'Acompanyeu-nos mentre ens donem el «sí,vull».' },
        { time: '16.30 h', title: 'Còctel', copy: 'Brindem plegats i gaudim de la tarda.' },
        { time: '18.00 h', title: 'Sopar i ball', copy: 'Bon menjar,llàgrimes d’alegria i una pista plena.' },
      ],
    },
    location: {
      eyebrow: 'Com arribar-hi',
      title: 'Ubicació',
      name: 'Restaurant Can Mont Cad',
      copy: 'Avinguda Pau Vila,1,08181 Pedra-Santa,Sentmenat,Barcelona.',
      button: 'Com arribar-hi',
      website: 'Visita el web',
    },
    dresscode: {
      eyebrow: 'Com vestir-se',
      title: 'Codi de vestimenta',
      copy: 'Vestiu-vos elegantment,però si us plau,eviteu el blanc i el vermell.',
    },
    stay: {
      eyebrow: 'Planifiqueu la vostra visita',
      title: 'Allotjament i transport',
      hotels: [
        { name: 'The Garden Hotel', detail: 'Hotel orientatiu · a 10 min del lloc de celebració' },
        { name: 'Casa del Mar', detail: 'Hotel orientatiu · a 15 min del lloc de celebració' },
        { name: 'The Riverside Inn', detail: 'Hotel orientatiu · a 20 min del lloc de celebració' },
      ],
      note: 'Hi haurà un autobús llançadora entre les zones d’allotjament i el lloc de celebració. Us donarem més detalls quan s’acosti la data.',
    },
    rsvp: {
      eyebrow: 'Ens agradaria molt que ens acompanyéssiu',
      title: 'Hi sereu?',
      copy: 'Feu-nos saber si podreu celebrar aquest dia tan especial amb nosaltres.',
    },
    rsvpForm: {
      name: 'Nom i cognoms',
      namePlaceholder: 'Escriviu el vostre nom',
      email: 'Adreça electrònica',
      emailPlaceholder: 'vosaltres@exemple.cat',
      attendance: 'Hi assistireu?',
      yes: 'Sí',
      no: 'No',
      guestCount: 'Nombre de convidats',
      guestCountPlaceholder: 'Nombre de convidats',
      dietary: 'Requisits alimentaris',
      dietaryPlaceholder: 'Indiqueu qualsevol requisit alimentari',
      message: 'Missatge',
      messagePlaceholder: 'Afegiu-hi un missatge (opcional)',
      submit: 'Envia la confirmació',
      sending: 'S’està enviant...',
      success: 'Gràcies. Hem desat la vostra confirmació.',
      error: 'No hem pogut desar la vostra confirmació. Torneu-ho a provar.',
    },
    gifts: {
      eyebrow: 'Una petita nota',
      title: 'Regals',
      copy: 'El millor regal és que ens acompanyeu. Si voleu contribuir al nostre viatge de noces,podeu fer servir les dades següents.',
      accountLabel: 'IBAN / Número de compte',
      account: 'IBAN PROVISIONAL · COMPTE 0000 0000 0000',
      copyButton: 'Copia al porta-retalls',
      copied: 'Copiat',
    },
    footer: 'Amb molt d’amor,Joan & Sofia',
  },
};